<template>
  <ViewerLayoutRoot class="content-owner-layout" data-testid="content-owner-layout">
    <ContentOwnerTopBar />

    <div class="content-owner-layout__content">
      <ViewerContent />
      <div v-if="isMobile" class="px-4 pt-4 pb-1">
        <ItemName />
      </div>
      <div class="px-4 sm:px-0">
        <MetadataSection />
      </div>
    </div>

    <div class="content-owner-layout__tabs px-4 sm:px-0">
      <ContentOwnerTabs @addedComment="emit('addedComment')" />
    </div>
  </ViewerLayoutRoot>
</template>

<script setup lang="ts">
import ViewerContent from '@/modules/viewer/components/Content.vue';
import ItemName from '@/modules/viewer/components/Name.vue';
import { useMobileDetection } from '@/composables/useMobileDetection';
import ContentOwnerTopBar from './ContentOwnerTopBar.vue';
import ContentOwnerTabs from './ContentOwnerTabs.vue';
import MetadataSection from '../../shared/MetadataSection.vue';

import ViewerLayoutRoot from '../../shared/ViewerLayoutRoot.vue';

const { isMobile } = useMobileDetection();

const emit = defineEmits<{
  addedComment: [];
}>();
</script>

<style scoped>
.content-owner-layout__content {
  @apply flex flex-col min-w-0;
}

.content-owner-layout__tabs {
  @apply mt-2;
}
</style>
